var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "opt-group" }, [
    _vm.showList.indexOf("amount") > -1
      ? _c("div", { attrs: { title: _vm.value } }, [_vm._v(_vm._s(_vm.value))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }